module.exports = __webpack_public_path__ + "static/img/white-1x.4c3dc04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/white-1x.png
// module id = I4Vy
// module chunks = 0